module.exports = __webpack_public_path__ + "static/img/mark6-CdDIbaU9.cdc943a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/mark6-CdDIbaU9.png
// module id = tziO
// module chunks = 16